// extracted by mini-css-extract-plugin
export var sliderRange = "_pm-2";
export var sliderRoot = "_pm-0";
export var sliderThumb = "_pm-3";
export var sliderTrack = "_pm-1";